const Productviewed = {
  init() {
    new Swiper(".productViewedSwiper", {
      loop: true,
      navigation: {
        nextEl: ".product-viewed .button-next",
        prevEl: ".product-viewed .button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        680: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        991: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 5,
          spaceBetween: 24,
        },
        1366: {
          slidesPerView: 6,
          spaceBetween: 24,
        },
      },
    });
  },
  handleInitPopupSizeGuideline() {
    // Open size guideline modal
    $(document).on("click", ".productDetail__seeSizeChart", function () {
      $("#product-guideline").modal("show");
    });
  },
};

$(function () {
  Productviewed.init();
  Productviewed.handleInitPopupSizeGuideline();
});
